import React from "react";
import i18n from "i18next";

/**
 * Skip Interactive checkbox — rendered in the scene mandatory-settings UI
 * only when the selected scene has at least one InteractivePlugin item.
 *
 * Persists to `viewToolbarsById[sceneId].skipInteractive` via UPDATE_VIEW_TOOLBAR.
 * When true, the Visor renders a bottom-right Skip button during the
 * interactive moment (see _visor/components/SkipInteractiveButton.jsx).
 *
 * @param {Object} props
 * @param {boolean} props.checked
 * @param {(next: boolean) => void} props.onChange
 * @param {boolean} [props.disabled]
 */
export default function SkipInteractiveCheckbox({ checked, onChange, disabled }) {
  return (
    <label
      className={`skip-interactive-checkbox${disabled ? " skip-interactive-checkbox--disabled" : ""}`}
      title={i18n.t("SkipInteractive.help", {
        defaultValue:
          "When checked, a Skip button appears on the right-bottom of the viewport during the interactive moment.",
      })}
    >
      <input
        type="checkbox"
        checked={!!checked}
        disabled={!!disabled}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className="skip-interactive-checkbox__label">
        {i18n.t("SkipInteractive.label", { defaultValue: "Skip Interactive" })}
      </span>
    </label>
  );
}
